/* =====================================================================
 * ROAMWALK Storefront Filters (rw-sf-filters.js)
 * 5,000点超コレクションでも動くフィルター。データ源=Storefront Search API。
 * 見た目は既存テーマのfacetsマークアップ/クラスを踏襲(進化的置換・JS失敗時は現状表示のまま)。
 * ===================================================================== */
(function () {
  'use strict';

  /* ---------- 設定読込 ---------- */
  var cfgEl = document.getElementById('RwSfConfig');
  if (!cfgEl) return;
  var CFG;
  try { CFG = JSON.parse(cfgEl.textContent); } catch (e) { return; }
  if (!CFG.handle || !CFG.token) return;

  var API_URL = '/api/2025-01/graphql.json';
  var PAGE_SIZE = CFG.pageSize || 16;
  var COUNTRY = (CFG.country || 'JP').toUpperCase();

  /* ---------- 既存カスタムJSと同じ分類写像 ---------- */
  var GROUPS = {
    'Tops': ['Long Sleeve T-Shirts', 'Polos', 'Shirts (Button Ups)', 'Short Sleeve T-Shirts', 'Sweaters & Knitwear', 'Sweatshirts & Hoodies', 'Tank Tops & Sleeveless'],
    'Bottoms': ['Casual Pants', 'Cropped Pants', 'Denim', 'Leggings', 'Overalls & Jumpsuits', 'Shorts', 'Sweatpants & Joggers'],
    'Outerwear': ['Bombers', 'Denim Jackets', 'Heavy Coats', 'Leather Jackets', 'Light Jackets', 'Parkas', 'Vests'],
    'Footwear': ['Boots', 'Casual Leather Shoes', 'Hi-Top Sneakers', 'Low-Top Sneakers', 'Sandals', 'Slip Ons'],
    'Accessories': ['Bags & Luggage', 'Belts', 'Glasses', 'Gloves & Scarves', 'Hats', 'Jewelry & Watches', 'Miscellaneous', 'Periodicals', 'Sunglasses', 'Ties & Pocketsquares', 'Wallets'],
    'Tailoring': ['Blazers', 'Suits']
  };
  var GROUP_ORDER_CAT = ['Tops', 'Bottoms', 'Outerwear', 'Footwear', 'Accessories', 'Tailoring'];
  var TYPE_ALIAS = { 'Outwear': 'Outerwear', 'Shoes': 'Footwear', 'Accessory': 'Accessories', 'Accessorie': 'Accessories' };
  var SUBCAT_TO_GROUP = {};
  Object.keys(GROUPS).forEach(function (g) { GROUPS[g].forEach(function (s) { SUBCAT_TO_GROUP[s] = g; }); });

  var ALPHA_SIZES = ['XXS', 'XS', 'S', 'M', 'L', 'XL', 'XXL', 'XXXL'];
  var ACCESSORY_SIZES = ['ONE SIZE', 'OS', 'FREE', 'ONE_SIZE', 'O/S', 'ONESIZE', 'N/A', '-'];
  var TAILORING_RE = /^\d{2}[SRL]$/i;
  function classifySize(val) {
    var u = String(val).toUpperCase().trim();
    if (ACCESSORY_SIZES.indexOf(u) !== -1) return 'Accessories';
    if (ALPHA_SIZES.indexOf(u) !== -1) return 'Tops / Outerwear';
    if (TAILORING_RE.test(u)) return 'Tailoring';
    var n = parseFloat(val);
    if (!isNaN(n)) {
      if (n >= 26 && n <= 44) return 'Bottoms';
      if (n >= 4 && n <= 16) return 'Footwear';
    }
    return 'Other';
  }
  var GROUP_ORDER_SIZE = ['Tops / Outerwear', 'Bottoms', 'Footwear', 'Tailoring', 'Accessories', 'Other'];
  function sizeSortKey(label) {
    var i = ALPHA_SIZES.indexOf(String(label).toUpperCase().trim());
    if (i !== -1) return [0, i, ''];
    var n = parseFloat(label);
    if (!isNaN(n)) return [1, n, ''];
    return [2, 0, String(label)];
  }

  /* ---------- 状態 ---------- */
  var state = {
    brand: [], cat: [], sub: [], size: [], color: [], cond: [],
    pmin: null, pmax: null,
    sort: null,           // sort_by値(テーマ形式)
    keyword: '',
    cursor: null,
    active: false          // 一度でも操作したらJS描画モード
  };
  var facetsCache = null;  // 直近のファセット
  var maxPrice = null;     // {amount, currencyCode}
  var fetching = false;

  var SORT_MAP = {
    'manual': { key: 'COLLECTION_DEFAULT', reverse: false },
    'best-selling': { key: 'BEST_SELLING', reverse: false },
    'title-ascending': { key: 'TITLE', reverse: false },
    'title-descending': { key: 'TITLE', reverse: true },
    'price-ascending': { key: 'PRICE', reverse: false },
    'price-descending': { key: 'PRICE', reverse: true },
    'created-ascending': { key: 'CREATED', reverse: false },
    'created-descending': { key: 'CREATED', reverse: true }
  };

  // 通貨換算(A案): APIはUSD基準で叩き、表示はJSで表示通貨へ換算。
  //   usdFactor : 表示通貨1単位 → USD (price入力の換算に使用)  = usdMax/dispMax
  //   dispRate  : USD1 → 表示通貨 (カード価格・ヒント表示に使用) = dispMax/usdMax
  //   dispCurrency: 表示通貨コード('JPY'等)。取得できるまではUSDそのまま表示。
  var usdFactor = 1;
  var dispRate = 1;
  var dispCurrency = 'USD';
  var rateReady = false;

  /* ---------- APIクライアント ---------- */
  function api(query, variables) {
    return fetch(API_URL, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        'X-Shopify-Storefront-Access-Token': CFG.token
      },
      body: JSON.stringify({ query: query, variables: variables || {} })
    }).then(function (r) { return r.json(); });
  }

  // ★@inContextを付けない(USD基準)。理由: 通貨コンテキスト下ではpriceフィルターが壊れる
  //   (範囲外商品が混ざる)Shopify制約。USD基準ならpriceは正しく効く。
  //   返るpriceはUSD → カード描画時にJSで表示通貨へ換算(dispRate)。
  var MAIN_QUERY = [
    'query($handle:String!,$filters:[ProductFilter!],$sortKey:ProductCollectionSortKeys,$reverse:Boolean,$first:Int!,$after:String)',
    '{',
    ' collection(handle:$handle){',
    '  products(first:$first,after:$after,filters:$filters,sortKey:$sortKey,reverse:$reverse){',
    '   filters{label values{label count input}}',
    '   pageInfo{hasNextPage endCursor}',
    '   nodes{',
    '    handle title vendor availableForSale',
    '    featuredImage{url altText width height}',
    '    priceRange{minVariantPrice{amount currencyCode}}',
    '    compareAtPriceRange{minVariantPrice{amount currencyCode}}',
    '    variants(first:1){nodes{title}}',
    '   }',
    '  }',
    ' }',
    '}'
  ].join('');

  // 検索API用クエリ(キーワード時)。totalCountで正確な件数が取れる。price共存のためUSD基準。
  var SEARCH_QUERY = [
    'query($q:String!,$filters:[ProductFilter!],$first:Int!,$after:String)',
    '{',
    ' search(query:$q,first:$first,after:$after,productFilters:$filters,types:PRODUCT){',
    '  totalCount',
    '  productFilters{label values{label count input}}',
    '  pageInfo{hasNextPage endCursor}',
    '  nodes{... on Product{',
    '   handle title vendor availableForSale',
    '   featuredImage{url altText width height}',
    '   priceRange{minVariantPrice{amount currencyCode}}',
    '   compareAtPriceRange{minVariantPrice{amount currencyCode}}',
    '   variants(first:1){nodes{title}}',
    '  }}',
    ' }',
    '}'
  ].join('');

  function canServerKeyword() {
    return !!state.keyword && (state.brand.length > 0 || !!CFG.vendorScope);
  }

  // ★キーワード検索のvendorスコープ: vendorフィルターは大文字小文字を厳密区別するため、
  //   カタログに混在する表記ゆれ("Chrome Hearts"/"Chrome hearts")を全てORで含める。
  //   ソース= Liquidのall_vendors値 + Brandファセットのinput実値 + 選択中ブランド。
  function keywordScopeFilters() {
    var vals = {};
    function add(v) { if (v) vals[v] = 1; }
    function lowerIn(list, v) {
      return list.some(function (x) { return String(x).toLowerCase() === String(v).toLowerCase(); });
    }
    var bf = facetsCache ? facetByLabel(facetsCache, 'Brand') : null;
    if (state.brand.length) {
      state.brand.forEach(add);
      if (CFG.vendorScope && lowerIn(state.brand, CFG.vendorScope)) add(CFG.vendorScope);
      if (bf) bf.values.forEach(function (v) {
        try {
          var i = JSON.parse(v.input);
          if (i && i.productVendor && lowerIn(state.brand, i.productVendor)) add(i.productVendor);
        } catch (e) { }
      });
    } else {
      add(CFG.vendorScope);
      if (bf && bf.values.length <= 5) bf.values.forEach(function (v) {
        try {
          var i = JSON.parse(v.input);
          if (i && i.productVendor && CFG.vendorScope &&
              i.productVendor.toLowerCase() === CFG.vendorScope.toLowerCase()) add(i.productVendor);
        } catch (e) { }
      });
    }
    return Object.keys(vals).map(function (v) { return { productVendor: v }; });
  }

  function buildFilters(excludeBrand) {
    var f = [];
    if (!excludeBrand) state.brand.forEach(function (v) { f.push({ productVendor: v }); });
    state.cat.forEach(function (v) { f.push({ productType: v }); });
    state.sub.forEach(function (v) { f.push({ tag: 'subcategory:' + v }); });
    state.size.forEach(function (v) { f.push({ variantOption: { name: 'Size', value: v } }); });
    state.color.forEach(function (v) { f.push({ productMetafield: { namespace: 'custom', key: 'color', value: v } }); });
    state.cond.forEach(function (v) { f.push({ productMetafield: { namespace: 'custom', key: 'condition', value: v } }); });
    if (state.pmin != null || state.pmax != null) {
      // ★priceフィルターはストア基準通貨(USD)で判定される。ユーザー入力は表示通貨なのでUSDへ換算。
      //   usdFactor = USD最高値 / 表示通貨最高値 (表示通貨1単位あたりのUSD)。US表示ならfactor=1。
      var p = {};
      if (state.pmin != null) p.min = state.pmin * usdFactor;
      if (state.pmax != null) p.max = state.pmax * usdFactor;
      f.push({ price: p });
    }
    return f;
  }

  /* ---------- URL状態 ---------- */
  var URL_KEYS = ['brand', 'cat', 'sub', 'size', 'color', 'cond'];
  function readUrl() {
    var p = new URLSearchParams(location.search);
    URL_KEYS.forEach(function (k) { state[k] = p.getAll('rwf_' + k); });
    state.pmin = p.has('rwf_pmin') ? parseFloat(p.get('rwf_pmin')) : null;
    state.pmax = p.has('rwf_pmax') ? parseFloat(p.get('rwf_pmax')) : null;
    state.sort = p.get('sort_by') || null;
    state.keyword = p.get('rwf_q') || '';
    state.active = URL_KEYS.some(function (k) { return state[k].length; }) ||
      state.pmin != null || state.pmax != null || !!p.get('rwf_q');
  }
  function writeUrl() {
    var p = new URLSearchParams();
    URL_KEYS.forEach(function (k) { state[k].forEach(function (v) { p.append('rwf_' + k, v); }); });
    if (state.pmin != null) p.set('rwf_pmin', state.pmin);
    if (state.pmax != null) p.set('rwf_pmax', state.pmax);
    if (state.keyword) p.set('rwf_q', state.keyword);
    if (state.sort) p.set('sort_by', state.sort);
    var qs = p.toString();
    history.replaceState(null, '', location.pathname + (qs ? '?' + qs : ''));
  }

  /* ---------- ユーティリティ ---------- */
  function el(tag, cls, html) {
    var e = document.createElement(tag);
    if (cls) e.className = cls;
    if (html != null) e.innerHTML = html;
    return e;
  }
  function esc(s) {
    return String(s).replace(/[&<>"']/g, function (c) {
      return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[c];
    });
  }
  function money(amount, currency) {
    try {
      return new Intl.NumberFormat(undefined, { style: 'currency', currency: currency }).format(parseFloat(amount)) + ' ' + currency;
    } catch (e) { return amount + ' ' + currency; }
  }
  // USD建てのMoneyV2を表示通貨へ換算(レート未確定/USD表示ならそのまま)
  function usdToDisp(mv) {
    if (!mv) return mv;
    if (!rateReady || dispCurrency === 'USD') return mv;
    return { amount: String(parseFloat(mv.amount) * dispRate), currencyCode: dispCurrency };
  }
  // 表示通貨で数値を整形(カンマ区切り・チップやヒント用)
  function moneyDisp(amountDisp) {
    return money(amountDisp, dispCurrency);
  }
  // 整数を3桁カンマ区切りにする(例: 23221 → 23,221)
  function withCommas(n) {
    return String(n).replace(/\B(?=(\d{3})+(?!\d))/g, ',');
  }
  // 「23221 listings」等の文字列中の先頭数値をカンマ区切りに
  function commaCount(text) {
    return String(text).replace(/\d[\d,]*/, function (m) { return withCommas(m.replace(/,/g, '')); });
  }
  function countLabel(n, hasMore) {
    var capped = n >= 5000;
    return (capped ? '5,000+' : withCommas(n)) + ' listings';
  }
  var CARET = '<svg xmlns="http://www.w3.org/2000/svg" width="10" height="10" viewBox="0 0 10 10" fill="none" style="transition:transform .2s"><path d="M1 3l4 4 4-4" stroke="currentColor" stroke-width="1.4" fill="none" stroke-linecap="round"/></svg>';

  /* ---------- サイドバー描画 ---------- */
  function facetByLabel(facets, label) {
    for (var i = 0; i < facets.length; i++) if (facets[i].label === label) return facets[i];
    return null;
  }

  function checkboxRow(label, count, checked, onChange) {
    var li = el('li', 'facets__item');
    var lab = el('label', 'facets__label facet-checkbox' + (checked ? ' active' : ''));
    var input = document.createElement('input');
    input.type = 'checkbox';
    input.checked = checked;
    input.addEventListener('change', function () { onChange(input.checked); });
    lab.appendChild(input);
    var txt = el('span', 'facet-checkbox__text',
      '<span class="facet-checkbox__text-label">' + esc(label) + '</span> (' + count + ')');
    lab.appendChild(txt);
    li.appendChild(lab);
    return li;
  }

  // ★フィルター選択→再描画してもユーザーが開いたグループを閉じないための開閉状態記憶
  var openDiscSet = {}, openSubSet = {}, prevBrandQuery = '';

  function disclosure(title, contentEl, openDefault) {
    // ★js-filterクラスは付けない(ネイティブfacets.jsのrenderFiltersに削除されるため)
    var det = el('details', 'facets__disclosure-vertical rw-sf-filter');
    det.dataset.rwtitle = title;
    if (openDefault || openDiscSet[title]) det.open = true;
    var sum = el('summary', 'facets__summary');
    sum.innerHTML = '<div><span class="facets__summary-label">' + esc(title) + '</span>' + CARET + '</div>';
    det.appendChild(sum);
    var disp = el('div', 'facets__display-vertical');
    var fs = el('fieldset', 'facets-wrap facets-wrap-vertical');
    fs.appendChild(contentEl);
    disp.appendChild(fs);
    det.appendChild(disp);
    return det;
  }

  function subGroup(title, count, childUl) {
    var li = document.createElement('li');
    var det = el('details', 'facets__subcategory-group');
    det.dataset.rwtitle = title;
    if (openSubSet[title]) det.open = true;
    var sum = el('summary', 'facets__subcategory-summary');
    sum.innerHTML = '<span>' + esc(title) + ' (' + count + ')</span><span class="facets__subcategory-caret">' + CARET + '</span>';
    det.appendChild(sum);
    det.appendChild(childUl);
    li.appendChild(det);
    return li;
  }

  function toggleValue(arr, value, on) {
    var i = arr.indexOf(value);
    if (on && i === -1) arr.push(value);
    if (!on && i !== -1) arr.splice(i, 1);
  }

  // API失敗時: 旧フィルターを復活させる(rw-sf-activeを外す=CSSの非表示が解除される)
  function showNativeFallback() {
    document.documentElement.classList.remove('rw-sf-active');
  }

  var nativeHidden = false;
  function hideNativeSidebar() {
    if (nativeHidden) return;
    nativeHidden = true;
    // ★このクラスが付いて初めてCSSが旧フィルターを隠す(成功時のみ=完全消失を防ぐ)
    document.documentElement.classList.add('rw-sf-active');
    // ★ネイティブのフィルターフォームはDOMごと削除する(facets.jsのAJAXが二度と発火しないように。
    //   display:noneだとイベントリスナーが生きていて、私のUIを上書き・削除してしまう)
    // ★保護: Google翻訳等がページのDOMを書き換えていると removeChild が例外(NotFoundError等)を投げる。
    //   その場合でも初期化を止めない(=自作サイドバーは描画される)ようtry/catchで囲む。
    //   本来は<aside translate="no">で翻訳自体を除外して衝突を防ぐが、多重の保険として残す。
    try {
      var formEl = document.getElementById('FacetFiltersForm');
      var wrapEl = formEl ? (formEl.closest('facet-filters-form') || formEl) : document.getElementById('FacetsWrapperDesktop');
      if (wrapEl && wrapEl.parentNode) wrapEl.parentNode.removeChild(wrapEl);
      document.querySelectorAll('.active-facets').forEach(function (e) {
        if (e.parentNode) e.parentNode.removeChild(e);
      });
      // 旧モバイルフィルタードロワー(5,000点超で機能しない)も除去 → 自前ドロワーに置換
      document.querySelectorAll('.mobile-facets__wrapper, #FacetFiltersFormMobile').forEach(function (e) {
        var w = e.closest('menu-drawer') || e;
        if (w.parentNode) w.parentNode.removeChild(w);
      });
      // 旧カスタムのモバイルバー2種(「N listings + FILTER」)も除去(二重表示の原因)
      var mb = document.getElementById('MobileStickyFilterBtn');
      if (mb) {
        var mw = mb.closest('[style*="sticky"]') || mb.parentNode;
        if (mw && mw.parentNode) mw.parentNode.removeChild(mw);
      }
      var mc = document.getElementById('ProductCountMobileBar');
      if (mc) {
        var md = mc.closest('details') || mc.closest('.mobile-facets__disclosure') || mc;
        if (md && md.parentNode) md.parentNode.removeChild(md);
      }
    } catch (e) { /* 翻訳等でDOMが変わっていてもフィルター描画は継続する */ }
  }

  /* ---- モバイルドロワー開閉 ---- */
  function openDrawer() { document.documentElement.classList.add('rw-sf-drawer-open'); }
  function closeDrawer() { document.documentElement.classList.remove('rw-sf-drawer-open'); }

  function drawerChrome(host) {
    // モバイル時のみCSSで表示されるドロワーヘッダー＋ソート
    var head = el('div', 'rw-sf-drawer-head');
    head.appendChild(el('span', 'rw-sf-drawer-title', 'Filter & Sort'));
    var close = el('button', 'rw-sf-drawer-close', '&times;');
    close.type = 'button';
    close.setAttribute('aria-label', 'Close');
    close.addEventListener('click', closeDrawer);
    head.appendChild(close);
    host.appendChild(head);

    // Sort by: 他フィルターと同じdisclosure UI(単一選択のチェック)
    var cur = state.sort || 'created-descending';
    var sUl = el('ul', 'facets__list--vertical list-unstyled');
    [['created-descending', 'Date, new to old'],
     ['created-ascending', 'Date, old to new'],
     ['price-ascending', 'Price, low to high'],
     ['price-descending', 'Price, high to low']].forEach(function (o) {
      var li = el('li', 'facets__item');
      var lab = el('label', 'facets__label facet-checkbox' + (cur === o[0] ? ' active' : ''));
      var input = document.createElement('input');
      input.type = 'checkbox';
      input.checked = (cur === o[0]);
      input.addEventListener('change', function () { state.sort = o[0]; apply(); });
      lab.appendChild(input);
      lab.appendChild(el('span', 'facet-checkbox__text',
        '<span class="facet-checkbox__text-label">' + esc(o[1]) + '</span>'));
      li.appendChild(lab);
      sUl.appendChild(li);
    });
    var sortWrap = el('div', 'rw-sf-drawer-sort');
    sortWrap.appendChild(disclosure('Sort by', sUl, false));
    host.appendChild(sortWrap);
  }

  function renderSidebar(facets) {
    var host = document.getElementById('RwSfSidebar');
    if (!host) return;
    hideNativeSidebar(); // ファセット取得成功時のみネイティブを隠す(フェイルセーフ)
    // ★再描画前に「今開いているグループ」と「ブランド検索語」を記憶し、描画後も維持する
    openDiscSet = {}; openSubSet = {};
    host.querySelectorAll('details.rw-sf-filter[open]').forEach(function (d) {
      if (d.dataset.rwtitle) openDiscSet[d.dataset.rwtitle] = 1;
    });
    host.querySelectorAll('details.facets__subcategory-group[open]').forEach(function (d) {
      if (d.dataset.rwtitle) openSubSet[d.dataset.rwtitle] = 1;
    });
    var pbq = host.querySelector('.rw-sf-brand-search');
    prevBrandQuery = pbq ? pbq.value : '';
    host.innerHTML = '';
    drawerChrome(host);
    // 見出し「Filter:」はサイドバーの最上部(グループの上)に置く
    host.appendChild(el('h2', 'facets__heading--vertical', 'Filter:'));

    /* --- Brand(検索付き) --- */
    var brandFacet = facetByLabel(facets, 'Brand');
    if (brandFacet && brandFacet.values.length) {
      var wrap = el('div');
      var search = document.createElement('input');
      search.type = 'search';
      search.placeholder = 'Search brands';
      search.className = 'rw-sf-brand-search field__input';
      wrap.appendChild(search);
      var ul = el('ul', 'facets__list--vertical list-unstyled rw-sf-brand-list');
      function drawBrands(q) {
        ul.innerHTML = '';
        brandFacet.values.forEach(function (v) {
          if (q && v.label.toLowerCase().indexOf(q) === -1) return;
          ul.appendChild(checkboxRow(v.label, v.count, state.brand.indexOf(v.label) !== -1, function (on) {
            toggleValue(state.brand, v.label, on); apply();
          }));
        });
      }
      // 再描画前の検索語を復元(選択で検索がリセットされるのを防ぐ)
      if (prevBrandQuery) search.value = prevBrandQuery;
      drawBrands(prevBrandQuery.toLowerCase().trim());
      search.addEventListener('input', function () { drawBrands(search.value.toLowerCase().trim()); });
      wrap.appendChild(ul);
      host.appendChild(disclosure('Brand', wrap, false));
    }

    /* --- Category(2階層: Product type × subcategory:タグ) --- */
    var typeFacet = facetByLabel(facets, 'Product type');
    var subFacet = facetByLabel(facets, 'Subcategory');
    if (subFacet || typeFacet) {
      var groups = {};
      (subFacet ? subFacet.values : []).forEach(function (v) {
        if (v.label.indexOf('subcategory:') !== 0) return;
        var name = v.label.slice('subcategory:'.length);
        var g = SUBCAT_TO_GROUP[name];
        if (!g) {
          // 未登録のsubcategoryはOtherに落ちる。将来の新カテゴリ追加を検知できるよう警告。
          console.warn('[rw-sf] unmapped subcategory -> Other:', name, '(GROUPSに追加を検討)');
          g = 'Other';
        }
        (groups[g] = groups[g] || []).push({ name: name, count: v.count });
      });
      var typeCount = {};
      (typeFacet ? typeFacet.values : []).forEach(function (v) {
        typeCount[TYPE_ALIAS[v.label] || v.label] = { raw: v.label, count: v.count };
      });
      var listUl = el('ul', 'facets__list--vertical list-unstyled');
      GROUP_ORDER_CAT.concat(['Other']).forEach(function (g) {
        var items = groups[g];
        if (!items || !items.length) return;
        var childUl = el('ul', 'facets__subcategory-list list-unstyled');
        items.forEach(function (it) {
          childUl.appendChild(checkboxRow(it.name, it.count, state.sub.indexOf(it.name) !== -1, function (on) {
            toggleValue(state.sub, it.name, on); apply();
          }));
        });
        var head = typeCount[g] ? typeCount[g].count : items.reduce(function (s, x) { return s + x.count; }, 0);
        listUl.appendChild(subGroup(g, head, childUl));
      });
      host.appendChild(disclosure('Category', listUl, false));
    }

    /* --- Size(グループ) --- */
    var sizeFacet = facetByLabel(facets, 'Size');
    if (sizeFacet && sizeFacet.values.length) {
      var grouped = {};
      sizeFacet.values.forEach(function (v) {
        var g = classifySize(v.label);
        (grouped[g] = grouped[g] || []).push(v);
      });
      var sUl = el('ul', 'facets__list--vertical list-unstyled');
      GROUP_ORDER_SIZE.forEach(function (g) {
        var items = grouped[g];
        if (!items || !items.length) return;
        items.sort(function (a, b) {
          var ka = sizeSortKey(a.label), kb = sizeSortKey(b.label);
          return ka[0] - kb[0] || ka[1] - kb[1] || String(ka[2]).localeCompare(kb[2]);
        });
        var childUl = el('ul', 'facets__subcategory-list list-unstyled');
        var total = 0;
        items.forEach(function (v) {
          total += v.count;
          childUl.appendChild(checkboxRow(v.label, v.count, state.size.indexOf(v.label) !== -1, function (on) {
            toggleValue(state.size, v.label, on); apply();
          }));
        });
        sUl.appendChild(subGroup(g, total, childUl));
      });
      host.appendChild(disclosure('Size', sUl, false));
    }

    /* --- Color --- */
    var colorFacet = facetByLabel(facets, 'Color');
    if (colorFacet && colorFacet.values.length) {
      var cUl = el('ul', 'facets__list--vertical list-unstyled');
      colorFacet.values.forEach(function (v) {
        cUl.appendChild(checkboxRow(v.label, v.count, state.color.indexOf(v.label) !== -1, function (on) {
          toggleValue(state.color, v.label, on); apply();
        }));
      });
      host.appendChild(disclosure('Color', cUl, false));
    }

    /* --- Price(From/To) --- */
    (function () {
      var box = el('div', 'rw-sf-price');
      var hint = el('div', 'rw-sf-price-hint');
      if (maxPrice) hint.textContent = 'The highest price is ' + money(maxPrice.amount, maxPrice.currencyCode);
      box.appendChild(hint);
      var row = el('div', 'rw-sf-price-row');
      var from = document.createElement('input');
      from.type = 'number'; from.placeholder = 'From'; from.min = '0'; from.className = 'field__input';
      if (state.pmin != null) from.value = state.pmin;
      var to = document.createElement('input');
      to.type = 'number'; to.placeholder = 'To'; to.min = '0'; to.className = 'field__input';
      if (state.pmax != null) to.value = state.pmax;
      function commit() {
        // ★From/Toを同時入力できるよう、change(blur)では反映せずApplyボタン/Enterでのみ確定
        state.pmin = from.value === '' ? null : parseFloat(from.value);
        state.pmax = to.value === '' ? null : parseFloat(to.value);
        apply();
      }
      // Enterキーは即確定のショートカット(From/Toどちらでも)
      [from, to].forEach(function (inp) {
        inp.addEventListener('keydown', function (e) { if (e.key === 'Enter') { e.preventDefault(); commit(); } });
      });
      row.appendChild(from); row.appendChild(to);
      box.appendChild(row);
      // Applyボタン: min/maxを揃えて入力してから反映
      var applyBtn = el('button', 'button button--secondary rw-sf-price-apply');
      applyBtn.type = 'button';
      applyBtn.textContent = 'Apply';
      applyBtn.addEventListener('click', commit);
      box.appendChild(applyBtn);
      host.appendChild(disclosure('Price', box, false));
    })();

    /* --- Condition --- */
    var condFacet = facetByLabel(facets, 'Condition');
    if (condFacet && condFacet.values.length) {
      var kUl = el('ul', 'facets__list--vertical list-unstyled');
      condFacet.values.forEach(function (v) {
        kUl.appendChild(checkboxRow(v.label, v.count, state.cond.indexOf(v.label) !== -1, function (on) {
          toggleValue(state.cond, v.label, on); apply();
        }));
      });
      host.appendChild(disclosure('Condition', kUl, false));
    }

    /* --- Keyword --- */
    (function () {
      var box = el('div');
      var inp = document.createElement('input');
      inp.type = 'search'; inp.placeholder = 'Filter by keyword'; inp.className = 'field__input';
      inp.value = state.keyword;
      var t;
      inp.addEventListener('input', function () {
        clearTimeout(t);
        t = setTimeout(function () {
          state.keyword = inp.value.trim();
          if (canServerKeyword() || !state.keyword) {
            apply();                       // サーバー検索(正確な件数・全件対象)で再取得
          } else {
            applyKeyword(); writeUrl(); renderChips();  // フォールバック(読み込み済のみ)
          }
        }, 400);
      });
      box.appendChild(inp);
      host.appendChild(disclosure('Filter By Keyword', box, false));
    })();

    /* --- モバイル: 結果を見るボタン(CSSでモバイルのみ表示) --- */
    var ab = el('button', 'button rw-sf-drawer-apply', 'View results');
    ab.id = 'RwSfDrawerApply';
    ab.type = 'button';
    ab.addEventListener('click', closeDrawer);
    host.appendChild(ab);
  }

  /* ---------- チップ ---------- */
  function chip(text, onRemove) {
    var a = el('span', 'active-facets__button rw-sf-chip');
    a.innerHTML = '<span class="active-facets__button-inner button button--tertiary">' + esc(text) + ' <span aria-hidden="true">×</span></span>';
    a.style.cursor = 'pointer';
    a.addEventListener('click', onRemove);
    return a;
  }
  function renderChips() {
    ['RwSfChips', 'RwSfChipsM'].forEach(function (id) {
      var host = document.getElementById(id);
      if (host) renderChipsInto(host);
    });
  }
  function renderChipsInto(bar) {
    bar.innerHTML = '';
    var any = false;
    function add(label, arr, v) {
      any = true;
      bar.appendChild(chip(label, function () { toggleValue(arr, v, false); apply(); }));
    }
    state.brand.forEach(function (v) { add('BRAND: ' + v, state.brand, v); });
    state.sub.forEach(function (v) { add('CATEGORY: ' + v, state.sub, v); });
    state.cat.forEach(function (v) { add('TYPE: ' + v, state.cat, v); });
    state.size.forEach(function (v) { add('SIZE: ' + v, state.size, v); });
    state.color.forEach(function (v) { add('COLOR: ' + v, state.color, v); });
    state.cond.forEach(function (v) { add('CONDITION: ' + v, state.cond, v); });
    if (state.pmin != null || state.pmax != null) {
      any = true;
      // state.pmin/pmaxは表示通貨建て。カンマ区切りの通貨表記でチップ表示。
      var lo = state.pmin != null ? moneyDisp(state.pmin) : moneyDisp(0);
      var hi = state.pmax != null ? moneyDisp(state.pmax) : '∞';
      bar.appendChild(chip('PRICE: ' + lo + ' - ' + hi, function () {
        state.pmin = null; state.pmax = null; apply();
      }));
    }
    if (state.keyword) {
      any = true;
      bar.appendChild(chip('"' + state.keyword.toUpperCase() + '"', function () {
        state.keyword = '';
        var host = document.getElementById('RwSfSidebar');
        if (host) { var inp = host.querySelector('input[placeholder="Filter by keyword"]'); if (inp) inp.value = ''; }
        apply();  // キーワード解除は常に再取得(クライアント絞りの残骸も一掃)
      }));
    }
    if (any) {
      var clear = el('span', 'rw-sf-clear underlined-link', 'Clear All');
      clear.style.cursor = 'pointer';
      clear.addEventListener('click', function () {
        URL_KEYS.forEach(function (k) { state[k] = []; });
        state.pmin = null; state.pmax = null; state.keyword = '';
        apply();
      });
      bar.appendChild(clear);
    }
  }

  /* ---------- 商品カード ---------- */
  function productCard(p) {
    var li = el('li', 'grid__item');
    var url = '/products/' + p.handle;
    var img = p.featuredImage;
    // APIはUSD基準で返るため、表示通貨へ換算(dispRate)して表示する
    var priceDisp = usdToDisp(p.priceRange.minVariantPrice);
    var compareDisp = p.compareAtPriceRange ? usdToDisp(p.compareAtPriceRange.minVariantPrice) : null;
    var price = priceDisp, compare = compareDisp;
    var onSale = compare && parseFloat(compare.amount) > parseFloat(price.amount);
    var size = (p.variants && p.variants.nodes && p.variants.nodes[0]) ? p.variants.nodes[0].title : '';
    var imgUrl = img ? img.url + (img.url.indexOf('?') === -1 ? '?' : '&') + 'width=533' : '';
    li.innerHTML =
      '<div class="card-wrapper product-card-wrapper underline-links-hover">' +
      ' <div class="card card--standard card--media">' +
      '  <div class="card__inner ratio" style="--ratio-percent: 125%;">' +
      '   <div class="card__media">' +
      '    <div class="media media--transparent media--hover-effect">' +
      (img ? '<img class="motion-reduce" loading="lazy" src="' + esc(imgUrl) + '" alt="' + esc(img.altText || p.title) + '">' : '') +
      '    </div>' +
      '   </div>' +
      '   <div class="card__badge bottom left">' +
      (!p.availableForSale ? '<span class="badge badge--bottom-left color-scheme-4">Sold out</span>' : '') +
      '   </div>' +
      '  </div>' +
      '  <div class="card__content">' +
      '   <div class="card__information">' +
      '    <div style="display:flex;justify-content:space-between;gap:.6rem;font-size:1.1rem;text-transform:uppercase;opacity:.75;">' +
      '     <div class="rw-sf-vendor">' + esc(p.vendor || '') + '</div>' +
      '     <div class="rw-sf-size">' + esc(size) + '</div>' +
      '    </div>' +
      '    <h3 class="card__heading h5"><a href="' + esc(url) + '" class="full-unstyled-link">' + esc(p.title) + '</a></h3>' +
      '    <div class="card-information"><div class="price' + (onSale ? ' price--on-sale' : '') + '">' +
      (onSale
        ? '<span class="price-item price-item--sale">' + money(price.amount, price.currencyCode) + '</span> <s class="price-item price-item--regular">' + money(compare.amount, compare.currencyCode) + '</s>'
        : '<span class="price-item price-item--regular">' + money(price.amount, price.currencyCode) + '</span>') +
      '    </div></div>' +
      '   </div>' +
      '  </div>' +
      ' </div>' +
      '</div>';
    return li;
  }

  /* ---------- グリッド描画 ---------- */
  function grid() { return document.getElementById('product-grid'); }
  function setLoading(on) {
    var c = document.querySelector('#ProductGridContainer .collection');
    if (c) c.classList.toggle('loading', !!on);
  }
  function updateCounts(totalText) {
    ['ProductCountDesktop', 'ProductCountMobileBar', 'StickyFilterCount', 'RwSfCount', 'RwSfMCount'].forEach(function (id) {
      var e = document.getElementById(id);
      if (e) e.textContent = totalText;
    });
    var ab = document.getElementById('RwSfDrawerApply');
    if (ab) ab.textContent = 'View ' + totalText;
  }
  function hideNativePagination(hide) {
    document.querySelectorAll('.pagination-wrapper').forEach(function (e) { e.style.display = hide ? 'none' : ''; });
  }
  function loadMoreBtn() {
    var btn = document.getElementById('RwSfLoadMore');
    if (!btn) {
      btn = el('button', 'button rw-sf-loadmore', 'Load More');
      btn.id = 'RwSfLoadMore';
      btn.type = 'button';
      var g = grid();
      if (g && g.parentNode) g.parentNode.insertBefore(btn, g.nextSibling);
      btn.addEventListener('click', function () { fetchPage(true); });
    }
    return btn;
  }

  function estimateTotal(facets) {
    // Condition/Colorファセットの合計=マッチ商品数(5,000でカンスト)
    var f = facetByLabel(facets, 'Condition') || facetByLabel(facets, 'Color');
    if (!f) return null;
    var s = 0;
    f.values.forEach(function (v) { s += v.count; });
    return s;
  }

  function applyKeyword() {
    var q = state.keyword.toLowerCase();
    var g = grid();
    if (!g) return;
    var visible = 0;
    Array.prototype.forEach.call(g.children, function (item) {
      var show = !q || item.textContent.toLowerCase().indexOf(q) !== -1;
      item.style.display = show ? '' : 'none';
      if (show) visible++;
    });
    if (q) updateCounts(visible + ' matching (loaded items)');
  }

  /* ---------- メイン取得 ---------- */
  function fetchPage(append) {
    if (fetching) return;
    fetching = true;
    setLoading(true);
    var useSearch = canServerKeyword();
    var req;
    if (useSearch) {
      // キーワード時: 検索API(全カタログ対象・正確なtotalCount)。
      // ブランド系フィルターは表記ゆれ対応のkeywordScopeFiltersに一本化(二重適用しない)
      var sf = buildFilters(true).concat(keywordScopeFilters());
      req = api(SEARCH_QUERY, {
        q: state.keyword, filters: sf,
        first: PAGE_SIZE, after: append ? state.cursor : null
      });
    } else {
      var sort = SORT_MAP[state.sort || 'created-descending'] || SORT_MAP['created-descending'];
      req = api(MAIN_QUERY, {
        handle: CFG.handle,
        filters: buildFilters(),
        sortKey: sort.key,
        reverse: sort.reverse,
        first: PAGE_SIZE,
        after: append ? state.cursor : null
      });
    }
    req.then(function (r) {
      fetching = false;
      setLoading(false);
      var prod, exactTotal = null;
      if (useSearch) {
        var sr = r && r.data && r.data.search;
        if (!sr) { console.warn('[rw-sf] no search data', r && r.errors); showNativeFallback(); return; }
        prod = { filters: sr.productFilters || [], pageInfo: sr.pageInfo, nodes: sr.nodes || [] };
        exactTotal = sr.totalCount;
      } else {
        var col = r && r.data && r.data.collection;
        if (!col) { console.warn('[rw-sf] no collection data', r && r.errors); showNativeFallback(); return; }
        prod = col.products;
      }
      facetsCache = prod.filters || [];
      state.cursor = prod.pageInfo.endCursor;

      var g = grid();
      if (g) {
        if (!append) g.innerHTML = '';
        prod.nodes.forEach(function (p) { g.appendChild(productCard(p)); });
        if (!append && prod.nodes.length === 0) {
          g.innerHTML = '<li class="grid__item" style="grid-column:1/-1;"><p>No products found. Try removing a filter.</p></li>';
        }
      }
      hideNativePagination(true);
      var btn = loadMoreBtn();
      btn.style.display = prod.pageInfo.hasNextPage ? '' : 'none';

      // 件数: 検索時=正確なtotalCount(1,000でカンストするため1,000+表示) / フィルターなし=初期表示 / 他=推計
      if (exactTotal != null) {
        updateCounts((exactTotal >= 1000 ? '1,000+' : withCommas(exactTotal)) + ' listings');
      } else if (buildFilters().length === 0 && !state.keyword && initialCountText) {
        updateCounts(initialCountText);
      } else {
        var total = estimateTotal(facetsCache);
        if (total != null) updateCounts(countLabel(total));
      }
      renderSidebar(facetsCache);
      renderChips();
      if (!useSearch) applyKeyword();  // サーバー検索が使えない環境のみクライアント側絞り
    }).catch(function (e) {
      fetching = false; setLoading(false);
      console.warn('[rw-sf] fetch error', e);
      showNativeFallback();
    });
  }

  function apply() {
    state.active = true;
    state.cursor = null;
    writeUrl();
    fetchPage(false);
  }

  /* ---------- 初期化 ---------- */
  function initSidebarHost() {
    // 自前サイドバーの挿し込み先を確保。
    // ★必ずネイティブ<facet-filters-form>要素の「外側」に置く(内側だとチェック操作が
    //   ネイティブfacets.jsのリスナーに伝播し、グリッド上書き・サイドバー削除が起きる)
    var host = el('div');
    host.id = 'RwSfSidebar';
    var formEl = document.getElementById('FacetFiltersForm');
    var wrapEl = formEl ? (formEl.closest('facet-filters-form') || formEl) : null;
    if (wrapEl && wrapEl.parentNode) {
      wrapEl.parentNode.insertBefore(host, wrapEl);
    } else {
      var aside = document.querySelector('aside.facets-wrapper, #main-collection-filters');
      if (!aside) return false;
      aside.insertBefore(host, aside.firstChild);
    }
    // 防御: 自前サイドバー内のイベントを外に漏らさない
    ['input', 'change', 'submit'].forEach(function (t) {
      host.addEventListener(t, function (e) { e.stopPropagation(); });
    });
    return true;
  }

  function initChips() {
    // ★テーマ既存のsticky件数+Sortバー(#DesktopSortBar/#FacetSortForm)をそのまま活かし、
    //   チップだけをその中(件数の隣)に差し込む。バーの移設・複製はしない。
    var chips = el('span', 'rw-sf-chips');
    chips.id = 'RwSfChips';
    var countEl = document.getElementById('ProductCountDesktop');
    if (countEl && countEl.parentNode) {
      countEl.insertAdjacentElement('afterend', chips);
    } else {
      var container = document.getElementById('ProductGridContainer');
      if (container) container.insertBefore(chips, container.firstChild);
    }
  }

  function initMobileBar() {
    // モバイル専用のsticky上部バー: 件数 + Filter & Sortボタン + チップ
    var container = document.getElementById('ProductGridContainer');
    if (!container || !container.parentNode) return;
    var bar = el('div', 'rw-sf-mbar');
    bar.setAttribute('translate', 'no'); // 翻訳除外(デスクトップの#DesktopSortBarと挙動を揃える)
    var row = el('div', 'rw-sf-mbar-row');
    var count = el('span', 'rw-sf-count');
    count.id = 'RwSfMCount';
    row.appendChild(count);
    var btn = el('button', 'rw-sf-mbar-btn', 'Filter &amp; Sort');
    btn.type = 'button';
    btn.addEventListener('click', openDrawer);
    row.appendChild(btn);
    bar.appendChild(row);
    var chips = el('div', 'rw-sf-chips');
    chips.id = 'RwSfChipsM';
    bar.appendChild(chips);
    container.parentNode.insertBefore(bar, container);
  }

  // stickyヘッダーの実高さをCSS変数に反映(バー/サイドバーの固定位置をヘッダー直下に揃える)
  function syncHeaderOffset() {
    var off = 0;
    document.querySelectorAll('.shopify-section-header-sticky, sticky-header, .section-header, #shopify-section-header').forEach(function (h) {
      var cs = getComputedStyle(h);
      if ((cs.position === 'sticky' || cs.position === 'fixed') && h.offsetHeight > off && h.offsetHeight < 300) {
        off = h.offsetHeight;
      }
    });
    document.documentElement.style.setProperty('--rw-sf-header-offset', off + 'px');
  }

  function initSort() {
    var sel = document.getElementById('SortBy');
    if (!sel) return;
    if (state.sort) sel.value = state.sort;
    var handled = false;
    // change/input両方を捕捉し、テーマ標準facets.jsへの伝播を遮断(グリッド上書き防止)
    ['change', 'input'].forEach(function (type) {
      sel.addEventListener(type, function (e) {
        e.stopImmediatePropagation();
        e.stopPropagation();
        if (type === 'input') return;            // 実処理はchange側のみ(二重発火防止)
        if (handled) return;
        handled = true;
        setTimeout(function () { handled = false; }, 50);
        state.sort = sel.value;
        apply();
      }, true);
    });
  }

  function fetchMaxPrice() {
    // 表示通貨(@inContext)とUSD(基準)の最高価格を取得し、換算レートと表示通貨を確定。
    // rateReady後に、既描画のカード価格・ヒントを表示通貨へ再描画する。
    var q = 'query($handle:String!,$country:CountryCode)@inContext(country:$country){collection(handle:$handle){products(first:1,sortKey:PRICE,reverse:true){nodes{priceRange{maxVariantPrice{amount currencyCode}}}}}}';
    var pDisp = api(q, { handle: CFG.handle, country: COUNTRY });
    var pUsd = api(q, { handle: CFG.handle, country: 'US' });
    return Promise.all([pDisp, pUsd]).then(function (rs) {
      try {
        var dispMv = rs[0].data.collection.products.nodes[0].priceRange.maxVariantPrice;
        var usdMax = parseFloat(rs[1].data.collection.products.nodes[0].priceRange.maxVariantPrice.amount);
        var dispMax = parseFloat(dispMv.amount);
        dispCurrency = dispMv.currencyCode || 'USD';
        if (dispMax > 0 && usdMax > 0 && dispCurrency !== 'USD') {
          usdFactor = usdMax / dispMax;   // 表示通貨1単位 → USD
          dispRate = dispMax / usdMax;    // USD1 → 表示通貨
        } else {
          usdFactor = 1; dispRate = 1; dispCurrency = 'USD';
        }
        // ヒント表示用の最高価格(表示通貨)
        maxPrice = { amount: String(dispMax), currencyCode: dispCurrency };
        rateReady = true;
        // レート確定後、既描画のサイドバー(価格ヒント)を更新
        if (facetsCache) renderSidebar(facetsCache);
      } catch (e) { usdFactor = 1; dispRate = 1; dispCurrency = 'USD'; rateReady = true; }
    }).catch(function () { usdFactor = 1; dispRate = 1; dispCurrency = 'USD'; rateReady = true; });
  }

  var initialCountText = '';
  function init() {
    readUrl();
    if (!initSidebarHost()) return;
    initChips();
    initMobileBar();
    initSort();
    var pc0 = document.getElementById('ProductCountDesktop');
    initialCountText = pc0 ? commaCount(pc0.textContent.trim()) : '';
    // SSRの件数表示もカンマ区切りに揃える
    if (pc0 && initialCountText) pc0.textContent = initialCountText;
    // モバイルバーの件数を初期表示(空のままにしない)
    var mc0 = document.getElementById('RwSfMCount');
    if (mc0 && initialCountText) mc0.textContent = initialCountText;
    syncHeaderOffset();
    window.addEventListener('resize', syncHeaderOffset);
    setTimeout(syncHeaderOffset, 1000); // フォント/画像読込後の高さ変動に追従
    var mpPromise = fetchMaxPrice();  // 換算レート確定(Promise)
    if (state.active) {
      // ディープリンク(URLにフィルター有)→レート確定後にJS描画(価格を表示通貨換算するため)
      mpPromise.then(function () { fetchPage(false); });
    } else {
      // 初期はSSRグリッド(先頭16件)を活かしつつ、同じ16件分のカーソルを取得して
      // ページネーションをLoad Moreに置き換える(SSRとAPIのデフォルトソートは同一=Date,new to old)
      var pageParam = parseInt(new URLSearchParams(location.search).get('page') || '1', 10);
      var sort = SORT_MAP['created-descending'];
      api(MAIN_QUERY, {
        handle: CFG.handle, filters: [], sortKey: sort.key, reverse: sort.reverse,
        first: PAGE_SIZE, after: null
      }).then(function (r) {
        var col = r && r.data && r.data.collection;
        if (!col) { showNativeFallback(); return; }
        var prod = col.products;
        facetsCache = prod.filters || [];
        // 件数はSSRの正確な値(例: 8173 listings)をそのまま残す
        renderSidebar(facetsCache);
        renderChips();
        if (pageParam === 1) {
          // 1ページ目: 番号ページネーション→Load Moreに統一
          state.cursor = prod.pageInfo.endCursor;
          hideNativePagination(true);
          var btn = loadMoreBtn();
          btn.style.display = prod.pageInfo.hasNextPage ? '' : 'none';
        }
        // 2ページ目以降のSSR着地(?page=N)は番号ページネーションを残す(重複回避)
      });
    }
  }

  // ★init全体を保護: 翻訳拡張(Google翻訳等)がDOMを書き換えて例外が出ても、
  //   未捕捉エラーでページ全体を巻き込まない。翻訳除外(translate="no")が主対策で、これは多重の保険。
  function bootRwSf() {
    try { init(); }
    catch (e) { if (window.console && console.warn) console.warn('[rw-sf] init aborted (translation/DOM interference?)', e); }
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', bootRwSf);
  else bootRwSf();
})();
